/*
 * Match centre information architecture. Each section lists the existing
 * match-page views (keyed by their original tab names) it now contains, so no
 * previous feature is dropped, only regrouped.
 */
export const SECTIONS = [
  { id: "overview", label: "Overview", subs: [["Preview", "Overview"]] },
  { id: "timeline", label: "Timeline", subs: [["Timeline", "Timeline"], ["Events", "Event feed"]] },
  { id: "lineups", label: "Lineups", subs: [["Lineups", "Lineup"], ["Players", "Players"], ["Injuries", "Injuries"], ["Props", "Player props"]] },
  { id: "stats", label: "Stats", subs: [["Stats", "Match stats"]] },
  { id: "analysis", label: "Analysis", subs: [["Advanced", "xG & tactics", "admin"], ["Form", "Form"], ["H2H", "Head to head"], ["Table", "Table"], ["Insights", "Insights"]] },
  { id: "odds", label: "Odds", subs: [["Edges", "Edges"], ["Live Odds", "Live odds"], ["Odds", "Odds table"], ["Predictions", "Predictions"]] },
  { id: "community", label: "Community", subs: [["Community", "Conversation"], ["News", "News"]] },
];

/** Section that owns a legacy tab key, or undefined. */
export const sectionOf = (key) => SECTIONS.find((s) => s.subs.some(([k]) => k === key));

/** Sub-views visible to this viewer: admin-only views are hidden, never disabled. */
export const subsFor = (sectionId, isAdmin) => {
  const sec = SECTIONS.find((s) => s.id === sectionId);
  if (!sec) return [];
  return sec.subs.filter(([, , gate]) => !gate || (gate === "admin" && isAdmin)).map(([key, label]) => ({ id: key, label }));
};
